// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal, Button } from 'antd';
import { CheckIcon } from 'images';

// @ts-ignore


class NotifModal extends React.Component {

  handleRedirect = () =>{
    this.props.isRedirected();
  };

  showScanFinger = () =>{
    this.props.showScan();
  };

  render() {
		const { isDisplay, hideModal } = this.props;

		return (
      <div className='health-info'>
        <Row onClick={hideModal}>
          <Modal
            visible={isDisplay}
            maskClosable
            footer={<Button type="primary" onClick={this.handleRedirect}>Continue</Button>}
          >
          <Row justify="center">
              <Col>
                <img
                  src={CheckIcon}
                  alt="logo"
                  style={{ height: 65, width: 50, paddingBottom: '1em' }}
                />
              </Col>
          </Row>
          <Row justify="center" style={{fontSize: 20}}>
                <Col>
                  Donor is NOT allowed to fillup <br></br>Health Information on the same day. 
                </Col>
              </Row>
          </Modal>
        </Row>
      </div>
    );
  }
}

NotifModal.propTypes = {
  isDisplay: PropTypes.bool.isRequired,
  isRedirected: PropTypes.func
};

export default NotifModal;
